'use client';

import { c as _c } from "react/compiler-runtime";
type Props = {
  className?: string;
  recommended?: boolean;
  title?: string;
  originalPrice?: string | number;
  price?: string | number;
  discountLabel?: string;
  planLabel?: string;
  benefits?: string[];
  ctaLabel?: string;
  onClick?: () => void;
};
export default function SubscribeDinamani(t0) {
  const $ = _c(40);
  const {
    className: t1,
    recommended: t2,
    title: t3,
    originalPrice: t4,
    price: t5,
    discountLabel: t6,
    planLabel: t7,
    benefits: t8,
    ctaLabel: t9,
    onClick
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const recommended = t2 === undefined ? true : t2;
  const title = t3 === undefined ? "Dinamani Premium" : t3;
  const originalPrice = t4 === undefined ? "\u20B9799" : t4;
  const price = t5 === undefined ? "\u20B9750" : t5;
  const discountLabel = t6 === undefined ? "Save 20%" : t6;
  const planLabel = t7 === undefined ? "1 Yr Plan" : t7;
  let t10;
  if ($[0] !== t8) {
    t10 = t8 === undefined ? ["The Yearly E-Paper Subscription Of Dinamani Comes All Editions E-Paper", "And Also With Gnayiru-Kondattam And Kadir", "And Also With Gnayiru-Kondattam And Kadir"] : t8;
    $[0] = t8;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  const benefits = t10;
  const ctaLabel = t9 === undefined ? "Buy Dinamani Premium 2" : t9;
  const t11 = `relative m-4 border border-DCDCDC bg-white p-4 ${className}`;
  let t12;
  if ($[2] !== recommended) {
    t12 = recommended && <div className="absolute -top-3 left-3 rounded-full bg-FFDB59 px-3 py-1 text-10-tamil600 text-222222 shadow">Recommended</div>;
    $[2] = recommended;
    $[3] = t12;
  } else {
    t12 = $[3];
  }
  let t13;
  if ($[4] !== title) {
    t13 = <div className="text-18-tamil-600 text-222222">{title}</div>;
    $[4] = title;
    $[5] = t13;
  } else {
    t13 = $[5];
  }
  let t14;
  if ($[6] !== planLabel) {
    t14 = <div className="text-16-tamil-400 text-6C6C6C">{planLabel}</div>;
    $[6] = planLabel;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  let t15;
  if ($[8] !== t13 || $[9] !== t14) {
    t15 = <div className="">{t13}{t14}</div>;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
  } else {
    t15 = $[10];
  }
  let t16;
  if ($[11] !== originalPrice) {
    t16 = <span className="text-16-tamil-400 text-6C6C6C line-through">{originalPrice}</span>;
    $[11] = originalPrice;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== price) {
    t17 = <span className="text-24-tamil-400 text-012061 font-bold text-[#1F5EC9]">{price}</span>;
    $[13] = price;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== t16 || $[16] !== t17) {
    t18 = <div className="flex gap-2">{t16}{t17}</div>;
    $[15] = t16;
    $[16] = t17;
    $[17] = t18;
  } else {
    t18 = $[17];
  }
  let t19;
  if ($[18] !== discountLabel) {
    t19 = discountLabel && <span className="ml-auto bg-E24E45 px-2 py-[2px] text-12-tamil-400 text-FFFFFF">{discountLabel}</span>;
    $[18] = discountLabel;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== t18 || $[21] !== t19) {
    t20 = <div className="flex flex-col items-baseline">{t18}{t19}</div>;
    $[20] = t18;
    $[21] = t19;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] !== t15 || $[24] !== t20) {
    t21 = <div className="space-y-1 flex justify-between gap-4 mt-4">{t15}{t20}</div>;
    $[23] = t15;
    $[24] = t20;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  let t22;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="mb-2 text-16-tamil-600 text-222222">Benefits</div>;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== benefits) {
    t23 = benefits.map(_temp);
    $[27] = benefits;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== t23) {
    t24 = <div className="mt-8 bg-E6F8FD p-4">{t22}<ul className="list-disc space-y-1 pl-5 text-14-tamil-400 text-222222">{t23}</ul></div>;
    $[29] = t23;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== ctaLabel || $[32] !== onClick) {
    t25 = <button type="button" onClick={onClick} className="mt-4 w-full bg-FFDB59 px-4 py-3 text-center text-14-tamil-600 text-222222 hover:bg-[#FFC34D]">{ctaLabel}</button>;
    $[31] = ctaLabel;
    $[32] = onClick;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t21 || $[37] !== t24 || $[38] !== t25) {
    t26 = <div className={t11}>{t12}{t21}{t24}{t25}</div>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t21;
    $[37] = t24;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  return t26;
}
function _temp(b, i) {
  return <li key={i}>{b}</li>;
}